import { render, staticRenderFns } from "./game-section.vue?vue&type=template&id=54d9dc32&"
import script from "./game-section.vue?vue&type=script&lang=js&"
export * from "./game-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports